interface ScrollLocation {
  pathname: string;
  state: unknown;
}

/**
 * Whether the content panel goes back to the top for `location`: react-admin asks for it with
 * `state._scrollToTop` (pagination, row clicks, redirects) but scrolls only the window, and a new
 * page starts at the top. A query-only change (a Home tab, a list filter) keeps the position.
 */
export const shouldScrollToTop = (previousPathname: string, location: ScrollLocation): boolean => {
  const state = location.state as { _scrollToTop?: unknown } | null;
  return location.pathname !== previousPathname || (typeof state === 'object' && state?._scrollToTop === true);
};
